(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsBenchmarkCompaniesFilters(
            module.exports,
            require('../../public/strings/strings.js')
        );

    } else {
        RivalIQ.module('enums');

        enumsBenchmarkCompaniesFilters(
            RivalIQ.enums,
            RivalIQ.strings
        );
    }

    function enumsBenchmarkCompaniesFilters(exports, strings) {
        const benchmarkCompaniesFilters = exports.benchmarkCompaniesFilters = {
            all_companies: {
                id: 'all_companies'
            },
            exclude_focus_company: {
                id: 'exclude_focus_company'
            }
        };

        exports.benchmarkCompareAgainstOptions = [
            {
                id: `${benchmarkCompaniesFilters.exclude_focus_company.id}_average`,
                name: 'Competitor Average',
                abbreviatedName: 'Competitor Avg.',
                customSummaryName: 'Average',
                aggregate: 'average',
                description: strings.exclude_focus_company_average_benchmark_general_description,
                specificMetricDescription: strings.exclude_focus_company_average_benchmark_specific_description,
                benchmarkCompaniesFilter: benchmarkCompaniesFilters.exclude_focus_company.id
            },
            {
                id: `${benchmarkCompaniesFilters.exclude_focus_company.id}_median`,
                name: 'Competitor Median',
                abbreviatedName: 'Competitor Med.',
                customSummaryName: 'Median',
                aggregate: 'median',
                description: strings.exclude_focus_company_median_benchmark_general_description,
                specificMetricDescription: strings.exclude_focus_company_median_benchmark_specific_description,
                benchmarkCompaniesFilter: benchmarkCompaniesFilters.exclude_focus_company.id
            },
            {
                id: `${benchmarkCompaniesFilters.exclude_focus_company.id}_sum`,
                name: 'Competitor Sum',
                abbreviatedName: 'Competitor Sum',
                customSummaryName: 'Total Sum',
                aggregate: 'sum',
                description: strings.exclude_focus_company_sum_benchmark_general_description,
                specificMetricDescription: strings.exclude_focus_company_sum_benchmark_specific_description,
                benchmarkCompaniesFilter: benchmarkCompaniesFilters.exclude_focus_company.id
            },
            {
                id: `${benchmarkCompaniesFilters.all_companies.id}_average`,
                name: 'Landscape Average',
                abbreviatedName: 'Landscape Avg.',
                customSummaryName: 'Average',
                aggregate: 'average',
                description: strings.all_companies_average_benchmark_general_description,
                specificMetricDescription: strings.all_companies_average_benchmark_specific_description,
                benchmarkCompaniesFilter: benchmarkCompaniesFilters.all_companies.id
            },
            {
                id: `${benchmarkCompaniesFilters.all_companies.id}_median`,
                name: 'Landscape Median',
                abbreviatedName: 'Landscape Med.',
                customSummaryName: 'Median',
                aggregate: 'median',
                description: strings.all_companies_median_benchmark_general_description,
                specificMetricDescription: strings.all_companies_median_benchmark_specific_description,
                benchmarkCompaniesFilter: benchmarkCompaniesFilters.all_companies.id
            },
            {
                id: `${benchmarkCompaniesFilters.all_companies.id}_sum`,
                name: 'Landscape Sum',
                abbreviatedName: 'Landscape Sum',
                customSummaryName: 'Sum',
                aggregate: 'sum',
                description: strings.all_companies_sum_benchmark_general_description,
                specificMetricDescription: strings.all_companies_sum_benchmark_specific_description,
                benchmarkCompaniesFilter: benchmarkCompaniesFilters.all_companies.id
            }
        ];
    }

}());
